"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Name = exports.Link = exports.CtaText = exports.Cta = exports.Content = exports.Container = exports.Category = exports.Bold = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Container = _styledComponents.default.div`
  padding: 0px 20px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  @media (min-width: 768px) {
    min-width: 60vw;
  }
`;
exports.Container = Container;
const Content = _styledComponents.default.div`
  display: flex;
`;
exports.Content = Content;
const CtaText = _styledComponents.default.p`
  ${(0, _typography.setFontSizes)({
  xs: '24px',
  sm: '40px',
  xl: '56px'
})}
  ${(0, _typography.setFont)({
  headline: true
})}
  line-height: 1em;
  max-width: 560px;
  margin: 0 0 32px;

  @media (min-width: 768px) {
    max-width: 50%;
    margin: 0 0 48px;
  }
`;
exports.CtaText = CtaText;
const Cta = _styledComponents.default.a`
  text-decoration: none;
  color: inherit;
  border: 1px solid;
  transition: 0.25s all;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (min-width: 768px) {
    padding: 0px 30px;
    display: inline-flex;
    width: auto;
  }

  p {
    font-family: 'univers-black', sans-serif;
    font-style: normal;
    font-weight: 900;
    line-height: 110%;
    transition: 0.25s all;
    text-transform: uppercase;
    margin: 0px;
    ${(0, _typography.setFont)({
  headline: true
})}
    ${(0, _typography.setFontSizes)({
  xs: '14px'
})}
  }

  &:hover {
    background-color: white;
    p {
      color: black;
    }
  }
`;
exports.Cta = Cta;
const Category = _styledComponents.default.h3`
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${(0, _typography.setFont)({
  bold: true
})}
  ${(0, _typography.setFontSizes)({
  xs: '11px',
  sm: '13px'
})}
  text-transform: uppercase;
  margin: 32px 0 10px;
`;
exports.Category = Category;
const Title = _styledComponents.default.p`
  margin: 0px 6px 0px 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${(0, _typography.setFont)({
  bold: true
})}
  ${(0, _typography.setFontSizes)({
  xs: '11px',
  sm: '13px'
})}
  line-height: 140%;
`;
exports.Title = Title;
const Name = _styledComponents.default.p`
  margin: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
  ${(0, _typography.setFont)({})}
  ${(0, _typography.setFontSizes)({
  xs: '11px',
  sm: '13px'
})}
  line-height: 140%;
`;
exports.Name = Name;
const Link = _styledComponents.default.a`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
`;
exports.Link = Link;
const Bold = _styledComponents.default.strong`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'univers-bold';
`;
exports.Bold = Bold;
//# sourceMappingURL=creditStyles.js.map